import React, { useState } from 'react'
import { VideoSegmentManager } from '../../../../VideoSegment/VideoSegmentManager';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./core-controlled-main-ui.css"
import Tools from '../../../../Misc/Tools';
import CoreDebugUI from './debug/core-debug-ui';

const url = new URL(window.location.href);
const search_params = url.searchParams;
const w: any = search_params.get('w');
const debugScenario = w === 'core-debug';

const CoreControlledMainUI = (props: CoreControlledUIConfig) => {
	// const [isInDebugScenario, setTextSizeVal] = useState(0);
	
	return (
		<div>
			{props.debugMode ? (<div className="core-controlled-main-ui-container" style={{
				...props.style
			}}>
				<CoreDebugUI debugScenario={debugScenario} videoSegmentManager={props.videoSegmentManager}></CoreDebugUI>
			</div>) : (null)}
			<ToastContainer />
		</div>
	);

};

export default CoreControlledMainUI;

export interface CoreControlledUIConfig {
	debugMode: boolean;
	videoSegmentManager: VideoSegmentManager;
	style?: any;
}